import { communityCategories } from "@/mocks/categories";

export type SortKey = "heat" | "latest" | "replies";

interface HotFilterBarProps {
  category: string;
  sort: SortKey;
  keyword: string;
  onCategoryChange: (slug: string) => void;
  onSortChange: (sort: SortKey) => void;
  onKeywordChange: (value: string) => void;
  resultCount: number;
}

const sortOptions: { key: SortKey; label: string; icon: string }[] = [
  { key: "heat", label: "热度优先", icon: "ri-fire-line" },
  { key: "latest", label: "最新发布", icon: "ri-time-line" },
  { key: "replies", label: "热评最多", icon: "ri-chat-3-line" },
];

export default function HotFilterBar({
  category,
  sort,
  keyword,
  onCategoryChange,
  onSortChange,
  onKeywordChange,
  resultCount,
}: HotFilterBarProps) {
  const tabs = [{ slug: "all", name: "全部" }, ...communityCategories];

  return (
    <div className="w-full bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4">
        <label className="flex items-center gap-2 flex-1 h-11 px-4 rounded-md bg-background-100 border border-background-200 focus-within:border-primary-400 focus-within:ring-2 focus-within:ring-primary-200 transition-colors">
          <i className="ri-search-line text-foreground-400"></i>
          <span className="sr-only">搜索热帖</span>
          <input
            value={keyword}
            onChange={(e) => onKeywordChange(e.target.value)}
            placeholder="搜索帖子标题、作者或标签…"
            className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
          />
          {keyword && (
            <button
              type="button"
              onClick={() => onKeywordChange("")}
              aria-label="清空搜索"
              className="text-foreground-400 hover:text-foreground-700 cursor-pointer"
            >
              <i className="ri-close-circle-fill"></i>
            </button>
          )}
        </label>

        <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200 self-start">
          {sortOptions.map((option) => (
            <button
              key={option.key}
              type="button"
              onClick={() => onSortChange(option.key)}
              className={`flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs md:text-sm whitespace-nowrap transition-colors cursor-pointer ${
                sort === option.key
                  ? "bg-foreground-950 text-background-50"
                  : "text-foreground-600 hover:text-foreground-900"
              }`}
            >
              <i className={option.icon}></i>
              {option.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-background-200 flex flex-wrap items-center gap-2">
        {tabs.map((tab) => (
          <button
            key={tab.slug}
            type="button"
            onClick={() => onCategoryChange(tab.slug)}
            className={`px-3.5 py-1.5 rounded-full text-xs md:text-sm whitespace-nowrap transition-colors cursor-pointer ${
              category === tab.slug
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-700 border border-background-200 hover:border-primary-300 hover:text-primary-700"
            }`}
          >
            {tab.name}
          </button>
        ))}
        <span className="ml-auto text-xs text-foreground-500 whitespace-nowrap">
          共 {resultCount} 条结果
        </span>
      </div>
    </div>
  );
}